// navigation/slice.js

import { navigationInitialState } from "./navigationState";
import { makeNavigationActions } from "./navigationActions";

export const createNavigationSlice = (set, get) => ({
  navigation: navigationInitialState,
  navigationActions: Object.freeze(makeNavigationActions(set, get)),
});
